export const values = [
  "A tailored home management plan for you and your family",
  "Unlimited access to the Humming Homes network of service professionals, local experts, and partners",
  "8 hours of guaranteed handyman contracting per year (a $400 value)",
  "Vendor bid management and pricing intelligence",
  "Digital invoices, and in-app bill pay"
];
